/* Shared by Popover, HoverCard and Combobox dropdowns. */
.dropdown {
    composes: dropdown from './Dropdown.module.css';
    --popover-border-color: var(--mantine-color-default-border);
    --popover-shadow: var(--mantine-shadow-md);
    background-color: var(--mantine-color-body);
}
